import { bool, string } from "prop-types";

import FnrSlides from "UI/FnrSlides";

import ActiveState from "./ActiveState";
import InactiveState from "./InactiveState";
import { useIsActive } from "./stateHooks";

const buttonDisplayConfig = [
  { value: ActiveState, key: "active" },
  { value: InactiveState, key: "inactive" },
];

const ButtonDisplay = ({ color, ...rest }) => {
  const isActive = useIsActive();
  return (
    <FnrSlides
      activeKey={isActive ? "active" : "inactive"}
      color={color}
      components={buttonDisplayConfig}
      variant="subtle"
      {...rest}
    />
  );
};

ButtonDisplay.propTypes = { color: string, isLoading: bool };

export default ButtonDisplay;
